import { createAction } from 'redux-actions';

export const formFinderConfigLoad = createAction('FORMFINDERCONFIG_LOAD');
export const formFinderConfigLoaded = createAction('FORMFINDERCONFIG_LOADED');
export const formFinderConfigUnload = createAction('FORMFINDERCONFIG_UNLOAD');
export const finderUpdateName = createAction('FINDER_UPDATENAME');
export const finderUpdateSections = createAction('FINDER_UPDATESECTIONS');
export const finderUpdatedSections = createAction('FINDER_UPDATEDSECTIONS');
export const finderChangeStep = createAction('FINDER_CHANGESTEP');
export const formFinderSave = createAction('FORMFINDER_SAVE');
export const formFinderSaved = createAction('FORMFINDER_SAVED');
export const formFinderSaveAndRedirect = createAction('FORMFINDER_SAVE_AND_REDIRECT');
export const formFinderDelete = createAction('FORMFINDER_DELETE');
export const formFinderDeleted = createAction('FORMFINDER_DELETED');
export const formFinderDiscardChanges = createAction('FORMFINDER_DISCARD_CHANGES');
